module.exports = __webpack_public_path__ + "img/GamesCom2.47f2cb0f.jpg";